// extracted by mini-css-extract-plugin
module.exports = {"certificates":"Certificates_certificates__EXPIg","certificates_container":"Certificates_certificates_container__132ks","certificate":"Certificates_certificate__-4Zay"};